import React from 'react'
import { motion } from "framer-motion";
import { BiMessageRoundedError } from 'react-icons/bi';
import { VscClose } from 'react-icons/vsc';

const ErrorModal = ({ closeErrorModal }) => {

    return (
        <div className="error-modal modal relative z-10 overflow-hidden">
            <div className="fixed inset-0 bg-[rgba(104,145,115,0.4)] transition-opacity" />
            <div className="fixed z-10 inset-0 overflow-y-auto">
                <motion.div initial={{ opacity: 0, y: '100%' }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.7 }} className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <div className="modal-card my-auto relative bg-[#113023] rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-[87vw] px-1 pb-2">
                        <div className="modal-content px-4 pt-5 pb-4">
                            <div className="mt-3 text-center sm:mt-0">
                                {/* <div className='sent-icon flex items-center justify-center'>
                                    <BiMessageRoundedError size='5rem' className='error-status text-[#f65624] animate-pulse' />
                                </div> */}
                                <div className="flex items-center justify-center mb-6">
                                    <BiMessageRoundedError size='5rem' className='error-status text-[#f65624]' />
                                </div>
                                <div className="text-center">
                                    <h3 className="text-white text-xl font-semibold mb-2 tracking-tight">
                                        Message not sent
                                    </h3>
                                    <p className="text-base">
                                        Something went wrong. Please check your connection and try again. If the issue persists, reach out directly at{' '}

                                        <a href="mailto:emuobopleasure@outlook.com"
                                            className="text-white underline underline-offset-2 hover:text-[#4deaa7] transition-colors duration-200"
                                        >
                                            emuobopleasure@outlook.com
                                        </a>
                                    </p>
                                    <div className="mt-8">
                                        <button onClick={closeErrorModal} className="w-full inline-flex justify-center border border-transparent rounded-md shadow-sm px-4 py-2 bg-[rgba(77,234,167,0.9)] hover:border-[#e5e5e5] hover:bg-transparent focus:border-[rgba(77,234,167,0.9)] text-lg font-semibold tracking-[0.5px] text-gray-700 hover:text-white sm:w-full sm:text-sm">
                                            Try Again
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="modal-close-btn cursor-pointer absolute top-0 right-0 mt-4 mr-5 focus:outline-none" onClick={closeErrorModal} aria-label="close modal">
                            <VscClose size='2rem' className='border focus:bg-[#4deaa7] rounded-[100%] p-[5px] hover:border-[#4deaa7] hover:bg-[#4deaa7] hover:text-[#113023] focus:border-[#4deaa7]' tabIndex='0' />
                        </button>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default ErrorModal